import { graphql, useStaticQuery } from 'gatsby'

const useHeaderBannerQueryHook = () => {
  const data = useStaticQuery(graphql`
    {
      wpPage(databaseId: { eq: 20 }) {
        page_main {
          headerBannerButton
          headerBannerText
          headerBannerUrl
        }
      }
    }
  `)
  return data.wpPage.page_main
}
export default useHeaderBannerQueryHook
